import api from '../../utils/axios';

/**
 * Voucher Theme Service
 * Handles API operations for persisting and retrieving custom voucher theme settings from the database.
 */
export const voucherThemeService = {
  /**
   * Fetch voucher theme for the authenticated agent
   */
  async getTheme() {
    try {
      const response = await api.get('/agent/profile');
      const agent = response.data?.data;
      if (agent?.voucher_theme) {
        return {
          isCustom: Boolean(agent.voucher_theme.is_custom),
          primaryColor: agent.voucher_theme.primary_color || '#0d9488',
          secondaryColor: agent.voucher_theme.secondary_color || '#1d4ed8',
          textColor: agent.voucher_theme.text_color || '#111827',
          headerBgColor: agent.voucher_theme.header_bg_color || '#ffffff',
          include_itinerary: Boolean(agent.voucher_theme.include_itinerary)
        };
      }
    } catch (error) {
      console.warn('Could not fetch voucher theme from DB, using fallback:', error);
    }
    return null;
  },

  /**
   * Update voucher theme in DB
   */
  async updateTheme(themeData) {
    const payload = {
      is_custom: Boolean(themeData.is_custom !== undefined ? themeData.is_custom : themeData.isCustom),
      primary_color: themeData.primary_color || themeData.primaryColor || '#0d9488',
      secondary_color: themeData.secondary_color || themeData.secondaryColor || '#1d4ed8',
      text_color: themeData.text_color || themeData.textColor || '#111827',
      header_bg_color: themeData.header_bg_color || themeData.headerBgColor || '#ffffff',
      include_itinerary: Boolean(themeData.include_itinerary)
    };

    const response = await api.put('/agent/voucher-theme', payload);
    return response.data?.voucher_theme;
  }
};

export const getSavedVoucherTheme = () => ({
  isCustom: false,
  primaryColor: '#0d9488',
  secondaryColor: '#1d4ed8',
  textColor: '#111827',
  headerBgColor: '#ffffff',
  include_itinerary: false
});
